import React from 'react';
import '../styles/mantenimiento.css';

const Mantenimiento = () => {
  const whatsappNumber = '+573112610669';
  const whatsappLink = `https://wa.me/${whatsappNumber.replace(/\D/g, '')}`;

  return (
    <div className="mantenimiento-container">
      <div className="mantenimiento-header">
        <h1>Mantenimiento</h1>
        <p>Servicios de mantenimiento preventivo y correctivo para garantizar el óptimo funcionamiento de tus sistemas</p>
      </div>

      <div className="mantenimiento-grid">
        <div className="mantenimiento-card">
          <div className="card-icon">
            <span className="material-icons">security_update_good</span>
          </div>
          <div className="card-content">
            <h3>Mantenimiento Preventivo</h3>
            <p className="card-description">Prevención de problemas antes de que ocurran</p>
            <p className="card-details">
              Realizamos revisiones periódicas y actualizaciones programadas para mantener tus sistemas funcionando de manera óptima y prevenir fallos futuros.
            </p>
            <p className="card-highlight">Máxima eficiencia y durabilidad</p>
            <p className="card-tagline">La prevención es la mejor solución</p>
          </div>
        </div>

        <div className="mantenimiento-card">
          <div className="card-icon">
            <span className="material-icons">build</span>
          </div>
          <div className="card-content">
            <h3>Mantenimiento Correctivo</h3>
            <p className="card-description">Solución rápida a problemas existentes</p>
            <p className="card-details">
              Nuestro equipo especializado interviene para reparar y corregir cualquier fallo en tus sistemas, restaurando su funcionamiento normal en el menor tiempo posible.
            </p>
            <p className="card-highlight">Respuesta inmediata y efectiva</p>
            <p className="card-tagline">Tu sistema funcionando en tiempo récord</p>
          </div>
        </div>

        <div className="mantenimiento-card">
          <div className="card-icon">
            <span className="material-icons">update</span>
          </div>
          <div className="card-content">
            <h3>Actualizaciones y Optimización</h3>
            <p className="card-description">Mejora continua de tus sistemas</p>
            <p className="card-details">
              Implementamos actualizaciones de software, optimizaciones de rendimiento y mejoras de seguridad para mantener tus sistemas al día y funcionando a su máximo potencial.
            </p>
            <p className="card-highlight">Sistemas actualizados y seguros</p>
            <p className="card-tagline">Innovación constante para tu negocio</p>
          </div>
        </div>
      </div>

      <div className="mantenimiento-contacto">
        <h2>¿Necesitas Servicio de Mantenimiento para tus Equipos?</h2>
        <div className="contacto-info">
          <div className="info-item">
            <span className="material-icons">phone</span>
            <p>+57 3112610669</p>
          </div>
          <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="info-item">
            <span className="material-icons">whatsapp</span>
            <p>+57 3112610669</p>
          </a>
          <div className="info-item">
            <span className="material-icons">schedule</span>
            <p>Lunes a Viernes: 9:00 - 18:00</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mantenimiento; 